import { Flex } from "rebass"
export default Flex
